import * as Yup from "yup";

import { ServicingPayment } from "@eave/shared/types/api";
import { YYYYMMDD } from "@eave/shared/utils/regex-patterns";

const reqStr = "required";

const dateRequired = Yup.string().matches(YYYYMMDD).required(reqStr);
const numberZeroOrGreaterRequired = Yup.number().min(0).required(reqStr);

export const validationSchema = Yup.object().shape({
  check_date: dateRequired,
  check_amount: Yup.number().moreThan(0, "must be greater than zero").required(reqStr),
  coupon_additional_principal: numberZeroOrGreaterRequired,
  coupon_additional_escrow: numberZeroOrGreaterRequired,
  coupon_late_charge: numberZeroOrGreaterRequired,
  coupon_fees: numberZeroOrGreaterRequired,
  coupon_mortgage_recoverable_advances: numberZeroOrGreaterRequired,
  coupon_total_amount_enclosed: numberZeroOrGreaterRequired,
  notes: Yup.string(),
});

export const getInitialValues = (p: ServicingPayment | undefined, period: string | undefined) => ({
  check_date: p ? p.check_date : period,
  check_amount: p ? p.check_amount : 0,
  coupon_additional_principal: p ? p.coupon_additional_principal : 0,
  coupon_additional_escrow: p ? p.coupon_additional_escrow : 0,
  coupon_late_charge: p ? p.coupon_late_charge : 0,
  coupon_fees: p ? p.coupon_fees : 0,
  coupon_mortgage_recoverable_advances: p ? p.coupon_mortgage_recoverable_advances : 0,
  coupon_total_amount_enclosed: p ? p.coupon_total_amount_enclosed : 0,
  notes: p ? p.notes : "",
});
